import React from "react";
import { Checkbox, FormControlLabel, InputLabel, Stack } from "@mui/material";
import { Divider } from "@aws-amplify/ui-react";

export const SpecialistSelector = ({
  specialists,
  selectedSpecialistIds,
  role,
  handleChangeSpecialist,
}) => {

  if (!Object.keys(specialists).length) return null;

  return (
    <Stack>
      <InputLabel sx={{ textAlign: "left" }}>{role}s</InputLabel>
      <Divider />
      {Object.keys(specialists).map((id) => {
        const { label } = specialists[id];
        const selected = selectedSpecialistIds.includes(id);
  
        return (
          <FormControlLabel
            key={id}
            control={
              <Checkbox
                checked={selected}
                onChange={(e) => handleChangeSpecialist(e, role, id, label)}
                name={id}
              />
            }
            label={label}
            sx={{
              textAlign: "left",
              "& .MuiFormControlLabel-label": {
                fontSize: "0.75rem",
                color: "#000000",
              },
            }}
          />
        );
      })}
    </Stack>
  );
};
